<template>
  <div>
    <div style=" font-size: 18px;padding-bottom: 20px;text-align: center;">
      {{this.areaId ? '编辑区域' : '新增区域'}}
    </div>
    <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" :model="form.data" :rules="formRules" ref="areaForm">
      <a-form-model-item label="区域名称" prop="name">
        <a-input v-model="form.data.name" auto-complete="off" placeholder="请输入区域名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="运输方式" prop="expressId">
        <a-select v-model="form.data.expressId" placeholder="请选择" clearable>
          <a-select-option
            v-for="item in shippingTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="到达天数" prop="days">
        <a-input v-model="form.data.days" auto-complete="off" placeholder="请输入到达天数"></a-input>
      </a-form-model-item>
<!--      <a-form-model-item label="揽收时间" :label-width="formLabelWidth" prop="">-->
<!--        <a-time-picker v-model="form.data.collectTime" auto-complete="off" placeholder="请输入揽收时间" style="width: 190px"-->
<!--                        value-format="HH:mm:ss" format="HH:mm:ss"></a-time-picker>-->
<!--      </a-form-model-item>-->
    </a-form-model>
<!--    <div slot="footer" class="dialog-footer">-->
<!--      <a-button type="primary" @click="cancel()"-->
<!--                 class="project-dialog-button">取消-->
<!--      </a-button>-->
<!--      <a-button type="primary" @click="save()"-->
<!--                 class="project-dialog-button">保存-->
<!--      </a-button>-->
<!--    </div>-->
  </div>
</template>

<script>

import {findArea, getShipping, saveArea, updateArea} from '../../../api/area';
import {positiveInteger} from '../../../utils/validateForm';

async function getShippingTypes() {
  const res = await getShipping();
  this.shippingTypeOptions = res.data.data
  // for (let item in res.data){
  //
  // }
}

async function getArea() {
  if (this.form.data.id) {
    this.form.data.name = this.form.data.id
    // const area = await findArea(this.form.data.id);
    // if (area.code === 1200) {
    //   this.form.data.id = area.data.areas.id;
    //   this.$set(this.form.data, 'name', area.data.areas.name);
    //   this.$set(this.form.data, 'days', area.data.areas.days);
    // }
  }
}

function save() {
  // let time = new Date();
  this.$refs.areaForm.validate(async (valid) => {
    if (valid) {
      if (this.form.data.id) {
        const resultUpdate = await updateArea(this.form.data);
        const messagesUpdate = '更新成功';
        if (resultUpdate.code === 1200) {
          // this.$message({
          //   message: messagesUpdate,
          //   type: 'success',
          // });
          this.$message.success(messagesUpdate)
          this.getList();
          this.form.data = {};
        } else {
          this.$message.error('更新失败');
        }
      } else {
        const resultAdd = await saveArea(this.form.data);
        const messagesAdd = '添加成功';
        if (resultAdd.code === 1200) {
          this.$message.success(messagesAdd);
          this.getList();
          this.form.data = {};
        } else {
          this.$message.error('添加失败');
        }
      }

      // if (this.onSaveHandler) {
        // this.onSaveHandler();
      // }
    }
  });
}

function cancel() {
  this.form.data = {};
  // if (this.onCancelHandler) {
  //   this.onCancelHandler();
  // }
}

// 判断到达天数格式
const integerFormat = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入到达天数'));
  }
  if (positiveInteger(value)) {
    callback();
  } else {
    return callback(new Error('输入格式不正确，请输入正整数'));
  }
};

export default {
  name: 'areaEdit',
  props: {
    areaId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
    getList: Function
  },
  data() {
    return {
      form: {
        data: {
          id: '',
          name: '',
          days: '',
          expressId: '',
          collectTime: '',
        },
      },
      shippingTypeOptions: [],
      formRules: {
        name: [
          { required: true, message: '请输入区域名称', trigger: 'blur' },
        ],
        expressId: [
          { required: true, message: '请输入运输方式', trigger: ['change','blur'] },
        ],
        days: [
          { required: true, validator: integerFormat, trigger: 'blur' },
        ]
      },
    };
  },
  watch: {
    areaId(val) {
      this.form.data.id = {};
      this.form.data.id = val;
      this.getArea();
    },
  },
  methods: {
    save,
    cancel,
    getArea,
    getShippingTypes,
  },
  created() {
    this.form.data.id = this.areaId;
    this.getArea();
    this.getShippingTypes();
  },

};
</script>

<style scoped>

</style>
